import './index.scss';
import * as Sentry from '@sentry/browser';
import SiteHeader from './ts/modules/site-header';
import Glitcher from './ts/modules/glitcher';
import SwiperGallery from './ts/modules/swiper-gallery';
import Lightbox from './ts/modules/lightbox';
import GlitchHover from './ts/modules/glitch-hover';
import YearsNav from './ts/modules/years-nav';
import Swup from 'swup';
import SwupProgressPlugin from '@swup/progress-plugin';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupHeadPlugin from '@swup/head-plugin';
import SwupA11yPlugin from '@swup/a11y-plugin';
import SwupScrollPlugin from '@swup/scroll-plugin';
import ReadMore from './ts/modules/read_more';
import GlitchLink from './ts/modules/glitch-link';
import ImageLoader from './ts/modules/image-loader';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  tunnel: '/sentry',
  environment: import.meta.env.VITE_ENV_MODE
});

const swup = new Swup({
  native: false, //true = trochu vic sekany nevim
  containers: ['#main', '.site-footer', '.site-header'],
  plugins: [
    new SwupProgressPlugin(),
    new SwupBodyClassPlugin({
      prefix: 'template-'
    }),
    new SwupHeadPlugin({
      attributes: ['lang'],
      persistAssets: true
    }),
    new SwupA11yPlugin({
      announcements: {
        'cs-CZ.utf-8': {
          visit: 'Přišli jste na stránku: {title}',
          url: 'Nová stránka na {url}'
        },
        'en-GB.utf-8': {
          visit: 'Navigated to: {title}',
          url: 'New page at {url}'
        },
      }
    }),
    new SwupScrollPlugin({
      animateScroll: {
        betweenPages: false,
        samePageWithHash: true,
        samePage: false
      },
      offset: () => {
        const siteHeader = document.querySelector('.site-header');
        if(siteHeader instanceof HTMLElement) {
          return siteHeader.offsetHeight;
        } else {
          return 0;
        }
      },
    })
  ]
});

let lightbox: Lightbox|null = null;
let yearsNav: YearsNav|null = null;
let glitcher: Glitcher|null = null;
let glitchHover: GlitchHover|null = null;
let glitchLinks: GlitchLink[] = [];
let swiperGalleries: SwiperGallery[] = [];
let readMores: ReadMore[] = [];
let imageLoader: ImageLoader|null = null

function init()
{
  lightbox = new Lightbox();
  imageLoader = new ImageLoader();

  const yearsNavWrapper = document.querySelector('.works-masonry-years-nav') as HTMLElement | null;
  if(yearsNavWrapper) {
    yearsNav = new YearsNav(yearsNavWrapper);
  }

  const canvas = document.getElementById('canvas');
  if(canvas instanceof HTMLCanvasElement) {
    glitcher = new Glitcher(canvas);
  }

  glitchHover = new GlitchHover('.works-masonry-year img, .exhibitions-list img');

  document.querySelectorAll('.swiper').forEach(element => {
    if(element instanceof HTMLElement) {
      swiperGalleries.push(new SwiperGallery(element));
    }
  })

  document.querySelectorAll(ReadMore.SELECTOR).forEach((element) => {
    if(element instanceof HTMLElement) {
     readMores.push(new ReadMore(element));
    }
  })

  document.querySelectorAll('.glitch-link').forEach((glitchLinkElement) => {
    if(glitchLinkElement instanceof HTMLElement) {
      glitchLinks.push(new GlitchLink(glitchLinkElement))
    }
  })
}

function unload()
{
  lightbox?.destroy();
  imageLoader?.destroy();
  yearsNav?.destroy();
  glitcher?.destroy();
  glitchHover?.destroy();
  swiperGalleries.forEach(swiperGallery => swiperGallery.destroy());
  readMores.forEach(readMore => readMore.destroy());
  glitchLinks.forEach(glitchLink => glitchLink.destroy());
}

// run once when page loads
if (document.readyState === 'complete') {
  init();
} else {
  document.addEventListener('DOMContentLoaded', () => init());
}

// Run after every additional navigation by swup
swup.hooks.on('page:view', () => init());

swup.hooks.before('content:replace', () => unload());